export enum SignatureStatus {
  ReadyToSend,
  WaitingForSending,
  Sent,
  Signed,
  Rejected
}
